/**
 * Suggestion — AI Elements pattern
 * Horizontal scrollable suggestion chips.
 */
import React, { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SuggestionsProps {
  children: ReactNode;
  className?: string;
}

export const Suggestions: React.FC<SuggestionsProps> = ({ children, className }) => {
  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {children}
    </div>
  );
};

interface SuggestionProps {
  suggestion: string;
  displayText?: string;
  onClick: (suggestion: string) => void;
  className?: string;
  variant?: 'neutral' | 'cta';
}

export const Suggestion: React.FC<SuggestionProps> = ({
  suggestion,
  displayText,
  onClick,
  className,
  variant = 'neutral',
}) => {
  return (
    <button
      type="button"
      onClick={() => onClick(suggestion)}
      className={cn(
        variant === 'cta'
          ? 'rounded-md border border-primary/25 bg-primary/5 dark:bg-primary/15 font-medium px-3 py-1 text-xs text-foreground dark:text-slate-100 assistant-suggestion-text assistant-suggestion transition-all hover:bg-primary/10 hover:border-primary/40 hover:shadow-sm'
          : 'rounded-md bg-slate-50 dark:bg-slate-800/80 font-normal px-3 py-1 text-xs assistant-suggestion-text dark:text-slate-200 assistant-suggestion transition-colors dark:border dark:border-slate-600/50',
        'active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35',
        'whitespace-nowrap',
        className,
      )}
    >
      {displayText ?? suggestion}
    </button>
  );
};
